import React from 'react'
import { checkTranslation } from '../../utils/useful';

class ButtonInput extends React.Component {

  onClick = () => {
    console.log('this.props', this.props.fullData)
    if (this.props.onClick) {
      this.props.onClick(this.props.header.information.action, this.props.fullData, this.props.header.information.action)
    }
  }

  render() {


    // let header = this.props.header?.information?.label
    return (

      <div className=" w-100" style={{ flex: 1, minHeight: 5, }}>
        <button style={this.props.styleInfo ?? { padding: '5px 10px', backgroundColor: '#ee5050', color: "#fff", borderRadius: 20 }} onClick={() => this.onClick()}>
          <p>{checkTranslation(this.props.header?.information?.label ?? '{{lang}}Button')}</p>
        </button>
      </div>


    )
  }
}

export default ButtonInput;